// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3QQ--","rootSuccess":"CompleteLink_rootSuccess__3mDll","rootFailure":"CompleteLink_rootFailure__3g7pX","isDisabled":"CompleteLink_isDisabled__2f404"};